export const EShapeStrokeSide = wcardinal.ui.EShapeStrokeSide;